import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

const MovieList = () => {
  let { id } = useParams();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [year, setYear] = useState("");
  const [duration, setDuration] = useState("");
  const [genre, setGenre] = useState("");
  const [rating, setRating] = useState("");
  const [image_url, setImage_url] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const result = await axios.get(
        `https://backendexample.sanbersy.com/api/data-movie/${id}`
      );
      console.log(result);
      setImage_url(result.data.image_url);
      setTitle(result.data.title);
      setDescription(result.data.description);
      setYear(result.data.year);
      setDuration(result.data.duration);
      setGenre(result.data.genre);
      setRating(result.data.rating);
    };
    fetchData();
  }, []);

  return (
    <div className="container">
      <div style={{ display: "flex", backgroundColor:"#f0f2f5", marginTop:"0px", padding:" 40px 40px" }}>
        <img
          src={image_url}
          alt="image"
          style={{ height: "400px", width: "300px", marginTop: "20px" }}
        />
        <div style={{ marginLeft: "100px", marginTop:"40px" }}>
          <div>
            <h2>
              {title}({year})
            </h2>
          </div>
          <div>
            .{genre} {duration}menit
          </div>
          <div>Rate {rating * 10}%</div>
          <h2>Overview</h2>
          <div>{description}</div>
        </div>
      </div>
    </div>
  );
};

export default MovieList;
